import {
	MDBDropdown,
	MDBDropdownItem,
	MDBDropdownMenu,
	MDBDropdownToggle,
} from "mdb-react-ui-kit";
import React, { useContext, useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { generateClient } from "aws-amplify/api";
import { UserContext } from "../App";
import { captureError } from "../utils/sentryHelpers";
import { normalizeLanguage } from "../utils/normalizeLanguage";

const client = generateClient();

export default function LangSelect({ style, className }) {
	const { i18n } = useTranslation();
	const { user } = useContext(UserContext);

	const [lngs, setLngs] = useState({ en: { nativeName: "English" } });

	useEffect(() => {
		if (i18n?.services?.backendConnector?.backend) {
			i18n.services.backendConnector.backend.getLanguages((err, ret) => {
				if (err) return; // TODO: handle err...
				//console.log("RES", ret)
				setLngs(ret);
			});
		}
	}, [i18n.services]);
	//console.log("LNGS", lngs)

	const persistUserLanguage = async (lng) => {
		const normalized = normalizeLanguage(lng);
		if (!user?.id || !normalized || normalizeLanguage(user.language) === normalized) return;
		try {
			await client.graphql({
				query: /* GraphQL */ `
					mutation UpdateUser($input: UpdateUserInput!) {
						updateUser(input: $input) {
							id
							language
						}
					}
				`,
				variables: { input: { id: user.id, language: normalized } },
			});
		} catch (error) {
			console.warn("error persisting user language", error);
			captureError(error, {
				feature: "i18n",
				operation: "persist-user-language",
				context: { userId: user.id, lng: normalized },
				tags: { component: "LangSelect" },
			});
		}
	};

	const handleChangeLang = (lng) => {
		i18n.changeLanguage(lng);
		persistUserLanguage(lng);
	};

	return (
		<MDBDropdown className={`langSelect ${className ?? ""}`} style={style}>
			<MDBDropdownToggle>
				<ReactCountryFlag
					countryCode={
						i18n.language === "en" || i18n.language === "en-US"
							? "gb"
							: i18n.language
					}
					svg
					style={{
						width: "20px",
						height: "20px",
					}}
					title={i18n.language}
				/>
			</MDBDropdownToggle>
			<MDBDropdownMenu>
				{Object.keys(lngs).map((lng) => (
					<MDBDropdownItem
						link
						key={lng}
						style={{ fontWeight: i18n.language === lng ? "bold" : "normal" }}
						onClick={() => handleChangeLang(lng)}
					>
						<ReactCountryFlag
							countryCode={lng === "en" ? "gb" : lng}
							svg
							style={{
								width: "20px",
								height: "20px",
							}}
							title={i18n.language}
						/>{" "}
						{lngs[lng].nativeName}
					</MDBDropdownItem>
				))}
			</MDBDropdownMenu>
		</MDBDropdown>
	);
}
